import ELementContentCustomerAddress from '@/components/sections/builder/elements/body/customer/customer_address/content';
import ElementSettingCustomerAddress from '@/components/sections/builder/elements/body/customer/customer_address/setting';
import { CustomerAddressElementDataType } from '@/components/sections/builder/elements/body/customer/customer_address/type';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: CustomerAddressElementDataType = {
  name: 'Addresses',
  topPadding: 20,
  bottomPadding: 20,
};

export const ELementPreviewIcon = BetweenHorizontalStart;

const CustomerAddress = {
  type: 'customer_address',
  group: 'body_customer_address',
  defaultData,
  PreviewIcon: ELementPreviewIcon,
  Element: ELementContentCustomerAddress,
  Setting: ElementSettingCustomerAddress,
  isImmutable: true,
  maxEntries: 1,
};

export default CustomerAddress;
